// markup/history.mjs — DropPin markup undo / redo (pure, headless).
// ---------------------------------------------------------------------------
// A minimal past/present/future history over immutable snapshots (the objects
// array). Pure functions returning new history objects — no React. One entry
// per committed interaction (draw, move, delete, paste, cut); live drags
// preview without pushing and commit a single entry on release.
// ---------------------------------------------------------------------------

export function createHistory(present) {
  return { past: [], present, future: [] };
}

// Push a new present (clears redo). No-op if identical reference.
export function pushHistory(h, next) {
  if (next === h.present) return h;
  return { past: [...h.past, h.present], present: next, future: [] };
}

// Replace present WITHOUT touching past/future (for live drag previews).
export function replacePresent(h, next) {
  return { past: h.past, present: next, future: h.future };
}

// Commit an interaction whose pre-state was `base`: one undo step restores base.
export function commitInteraction(h, base, next) {
  if (next === base) return replacePresent(h, next);
  return { past: [...h.past, base], present: next, future: [] };
}

export function undo(h) {
  if (!h.past.length) return h;
  const previous = h.past[h.past.length - 1];
  return { past: h.past.slice(0, -1), present: previous, future: [h.present, ...h.future] };
}

export function redo(h) {
  if (!h.future.length) return h;
  const next = h.future[0];
  return { past: [...h.past, h.present], present: next, future: h.future.slice(1) };
}

export function canUndo(h) { return h.past.length > 0; }
export function canRedo(h) { return h.future.length > 0; }
